var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.53 20.97L17.689 17.129C18.973 15.606 19.75 13.643 19.75 11.5C19.75 6.675 15.825 2.75 11 2.75C6.175 2.75 2.25 6.675 2.25 11.5C2.25 16.325 6.175 20.25 11 20.25C13.143 20.25 15.106 19.473 16.629 18.189L20.47 22.03C20.616 22.176 20.808 22.25 21 22.25C21.192 22.25 21.384 22.177 21.53 22.03C21.823 21.738 21.823 21.263 21.53 20.97ZM3.75 11.5C3.75 7.502 7.002 4.25 11 4.25C14.998 4.25 18.25 7.502 18.25 11.5C18.25 15.498 14.998 18.75 11 18.75C7.002 18.75 3.75 15.498 3.75 11.5ZM14 10.75H11.75V8.5C11.75 8.086 11.414 7.75 11 7.75C10.586 7.75 10.25 8.086 10.25 8.5V10.75H8C7.586 10.75 7.25 11.086 7.25 11.5C7.25 11.914 7.586 12.25 8 12.25H10.25V14.5C10.25 14.914 10.586 15.25 11 15.25C11.414 15.25 11.75 14.914 11.75 14.5V12.25H14C14.414 12.25 14.75 11.914 14.75 11.5C14.75 11.086 14.414 10.75 14 10.75Z",
    fill: "#3A0299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlus);
export default __webpack_public_path__ + "static/media/search-plus.79639cc140c2f93a6520def17c52ff5c.svg";
export { ForwardRef as ReactComponent };